// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b3ad1d65","72":"637a3d51","75":"50060ec5","108":"fd3e5e33","154":"3d5dab14","173":"d8413106","287":"b9f5c94a","495":"b9184a9e","580":"de8a7cd6","683":"3218fb0b"}[chunkId] + ".chunk.js";
};